const getters = {

    getBaseUrl: state => state.baseUrl,
    getCurrentPageDirection: state => state.navigationDirection,
    getCurrentPage: state => state.currentPage,
    getAllPageContent: (state) => state.pageContent,
    getActiveContent: (state) => state.activeContent,
    getReadingContent: (state) => state.readingContent,
    getNavigatingPages: (state) => state.navigatingPages,
    getCloseContent: (state) => state.closeContent,
    getManagingCookies: (state) => state.managingCookies


}

export default getters;